var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Grid, Hidden } from '@material-ui/core';
import { Toggle } from '@one-thd/sui-atomic-components';
import { ArrowBack, ArrowForward } from '@one-thd/sui-icons';
import { RenderSpendStatus, RenderSlideContainer, handleSlideTransition, PreviousSlideClass, } from '../../../commons/PerkProgressSpendCommons';
import { RenderLeftIcon, RenderRightIcon, RenderLeftMobileIcon, RenderRightMobileIcon, RenderlMobileProgressCircle, } from './PerkProgressSpendNavigation';
import { clickCta, setEditEvent } from '../../../../../../utils/analytics';
import { PerkProgressContext, InfoPerksContext, } from '../../../../../../contexts';
var userManagementAnalytics = {
    pushMyAccountButtonEvent: function (str) { return clickCta(str); },
};
// Utilities
var useClickHandlers = function () {
    var _a = React.useContext(PerkProgressContext), filterData = _a.filterData, currentDataIndex = _a.currentDataIndex, showUnlockAnimation = _a.showUnlockAnimation, setSlideClass = _a.setSlideClass, setShowUnlockAnimation = _a.setShowUnlockAnimation, setPrevDataIndex = _a.setPrevDataIndex, setCurrentDataIndex = _a.setCurrentDataIndex;
    var handleAnimation = function (animationProps) {
        var _a, _b, _c;
        var condition = animationProps.condition, direction = animationProps.direction, index = animationProps.index;
        if (condition) {
            var animateTiers = __spreadArray([], showUnlockAnimation, true);
            if (animateTiers[currentDataIndex] &&
                ((_c = (_b = (_a = filterData[currentDataIndex]) === null || _a === void 0 ? void 0 : _a.tierPerks) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.perkStatus) === 'UNCLAIMED') {
                animateTiers[currentDataIndex] = false;
                setShowUnlockAnimation(animateTiers);
            }
            handleSlideTransition(direction, setSlideClass);
            var currentDataNavigation = index;
            setPrevDataIndex(currentDataIndex);
            setCurrentDataIndex(currentDataNavigation);
            userManagementAnalytics.pushMyAccountButtonEvent("perks: progress tracker");
        }
    };
    var handleLeftClick = function () {
        return handleAnimation({
            condition: currentDataIndex > 0,
            direction: 'prev',
            index: currentDataIndex - 1,
        });
    };
    var handleRightClick = function () {
        return handleAnimation({
            condition: currentDataIndex < filterData.length - 1,
            direction: 'next',
            index: currentDataIndex + 1,
        });
    };
    return { handleLeftClick: handleLeftClick, handleRightClick: handleRightClick };
};
// Icons
var useRenderIcons = function () {
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var _a = React.useContext(PerkProgressContext), filterData = _a.filterData, initialCurrentDataIndex = _a.initialCurrentDataIndex, currentDataIndex = _a.currentDataIndex, slideClass = _a.slideClass, prevDataIndex = _a.prevDataIndex;
    var choosePerk = function () {
        if (currentDataIndex > initialCurrentDataIndex) {
            return true;
        }
        return false;
    };
    var TrackerLeftIcon = function (iconProps) {
        var prevData = iconProps.prevData, data = iconProps.data;
        var prev = slideClass === PreviousSlideClass;
        var previousPerk = prevDataIndex > 0 ? (React.createElement(RenderLeftIcon, { data: prevData, stateData: perksInfo, choosePerk: function () { return choosePerk; } })) : ('');
        var currentPerk = currentDataIndex > 0 ? (React.createElement(RenderLeftIcon, { data: data, stateData: perksInfo, choosePerk: function () { return choosePerk; } })) : ('');
        if (prev) {
            return (React.createElement(RenderSlideContainer, { itemClassString: slideClass, isPrev: prev },
                currentPerk,
                previousPerk));
        }
        return (React.createElement(RenderSlideContainer, { itemClassString: slideClass, isPrev: prev },
            prevDataIndex !== currentDataIndex && previousPerk,
            currentPerk));
    };
    var TrackerRightIcon = function (iconProps) {
        var nextData = iconProps.nextData, data = iconProps.data;
        var prev = slideClass === PreviousSlideClass;
        var previousPerk = prevDataIndex < filterData.length - 1 ? (React.createElement(RenderRightIcon, { data: nextData, stateData: perksInfo, filterData: filterData, currentDataIndex: prevDataIndex })) : ('');
        var currentPerk = currentDataIndex < filterData.length - 1 ? (React.createElement(RenderRightIcon, { data: data, stateData: perksInfo, filterData: filterData, currentDataIndex: currentDataIndex })) : ('');
        if (prev) {
            return (React.createElement(RenderSlideContainer, { itemClassString: slideClass, isPrev: true },
                currentPerk,
                prevDataIndex !== currentDataIndex && previousPerk));
        }
        return (React.createElement(RenderSlideContainer, { itemClassString: slideClass, isPrev: false },
            prevDataIndex !== currentDataIndex && previousPerk,
            currentPerk));
    };
    var TrackerLeftMobileIcon = function (iconProps) {
        var prevData = iconProps.prevData, data = iconProps.data;
        var tabletClass = slideClass;
        var prev = slideClass === PreviousSlideClass;
        var previousPerk = prevDataIndex > 0 ? (React.createElement(RenderLeftMobileIcon, { data: prevData, stateData: perksInfo, choosePerk: function () { return choosePerk; } })) : ('');
        var currentPerk = currentDataIndex > 0 ? (React.createElement(RenderLeftMobileIcon, { data: data, stateData: perksInfo, choosePerk: function () { return choosePerk; } })) : ('');
        if (prev) {
            return (React.createElement(RenderSlideContainer, { itemClassString: tabletClass, isPrev: prev },
                currentPerk,
                previousPerk));
        }
        return (React.createElement(RenderSlideContainer, { itemClassString: tabletClass, isPrev: prev },
            prevDataIndex !== currentDataIndex && previousPerk,
            currentPerk));
    };
    var TrackerRightMobileIcon = function (iconProps) {
        var nextData = iconProps.nextData, data = iconProps.data;
        var tabletClass = slideClass;
        var prev = slideClass === PreviousSlideClass;
        var previousPerk = prevDataIndex < filterData.length - 1 ? (React.createElement(RenderRightMobileIcon, { data: nextData, stateData: perksInfo, filterData: filterData, currentDataIndex: prevDataIndex })) : ('');
        var currentPerk = currentDataIndex < filterData.length - 1 ? (React.createElement(RenderRightMobileIcon, { data: data, stateData: perksInfo, filterData: filterData, currentDataIndex: currentDataIndex })) : ('');
        if (prev) {
            return (React.createElement(RenderSlideContainer, { itemClassString: tabletClass, isPrev: prev },
                currentPerk,
                prevDataIndex !== currentDataIndex && previousPerk));
        }
        return (React.createElement(RenderSlideContainer, { itemClassString: tabletClass, isPrev: prev },
            prevDataIndex !== currentDataIndex && previousPerk,
            currentPerk));
    };
    return {
        TrackerLeftIcon: TrackerLeftIcon,
        TrackerLeftMobileIcon: TrackerLeftMobileIcon,
        TrackerRightIcon: TrackerRightIcon,
        TrackerRightMobileIcon: TrackerRightMobileIcon,
    };
};
var RenderDesktopProgressCircle = function (props) {
    var data = props.data, perksInfo = props.perksInfo, controlToggle = props.controlToggle, detailsPlcc = props.detailsPlcc, plccSwitch = props.plccSwitch, isLoading = props.isLoading, showUnlockAnimation = props.showUnlockAnimation, currentDataIndex = props.currentDataIndex;
    var showUnlockAnimateTier = showUnlockAnimation[currentDataIndex];
    return (React.createElement(RenderlMobileProgressCircle, { data: data, stateData: perksInfo, PerkInfo: perksInfo, controlToggle: controlToggle, detailsPlcc: detailsPlcc, plccSwitch: plccSwitch, isLoading: isLoading, showUnlockAnimateTier: showUnlockAnimateTier }));
};
var ShowSpendStatus = function (props) {
    var data = props.data, showUnlockAnimation = props.showUnlockAnimation;
    var _a = React.useContext(InfoPerksContext), perksInfo = _a.perksInfo, isLoading = _a.isLoading;
    var currentDataIndex = React.useContext(PerkProgressContext).currentDataIndex;
    var showUnlockAnimateTier = showUnlockAnimation[currentDataIndex];
    return (React.createElement(RenderSpendStatus, { data: data, PerkInfo: perksInfo, showUnlockAnimateTier: showUnlockAnimateTier, isLoading: isLoading }));
};
// Render Navigation
var LeftNavigationDesktop = function (props) {
    var currentDataIndex = props.currentDataIndex;
    var handleLeftClick = useClickHandlers().handleLeftClick;
    var addedCss = "perkSpend-btn ".concat(currentDataIndex === 0 ? 'perkSpend-prev-firstLeftArrow' : 'perkSpend-prev');
    return (React.createElement(Grid, { item: true, className: "PerkSpend-nav " },
        React.createElement("button", { type: "button", disabled: currentDataIndex === 0, onClick: handleLeftClick, className: addedCss },
            React.createElement(ArrowBack, { size: "small", color: "current" })),
        React.createElement("div", { className: "perkSpend-prev perkSpend-whiteSpace" })));
};
var RightNavigationDesktop = function (props) {
    var filterData = props.filterData, currentDataIndex = props.currentDataIndex;
    var handleRightClick = useClickHandlers().handleRightClick;
    var firstRightArrow = "perkSpend-btn ".concat(currentDataIndex === filterData.length - 1
        ? 'perkSpend-prev-firstRightArrow'
        : 'perkSpend-next');
    return (React.createElement(Grid, { className: "PerkSpend-nav" },
        React.createElement("button", { type: "button", disabled: currentDataIndex === filterData.length - 1, onClick: handleRightClick, className: firstRightArrow },
            React.createElement(ArrowForward, { size: "small", color: "current" })),
        React.createElement("div", { className: "perkSpend-next perkSpend-whiteSpace" })));
};
var LeftNavigationTablet = function (props) {
    var currentDataIndex = props.currentDataIndex;
    var handleLeftClick = useClickHandlers().handleLeftClick;
    var mobileArrowLeft = "pps-mobileArrow pps-mobileArrow-Tablet ".concat(currentDataIndex === 0
        ? 'pps-mobileLeftArrowDisable pps-mobileLeftArrowDisableTablet '
        : 'pps-mobileLeftArrow pps-mobileLeftArrowTablet');
    return (React.createElement("div", { className: "sui-relative" },
        React.createElement("button", { type: "button", disabled: currentDataIndex === 0, onClick: handleLeftClick, className: mobileArrowLeft },
            React.createElement(ArrowBack, { color: "current" }))));
};
var RightNavigationTablet = function (props) {
    var filterData = props.filterData, currentDataIndex = props.currentDataIndex;
    var handleRightClick = useClickHandlers().handleRightClick;
    var mobileArrowRight = "pps-mobileArrow pps-mobileArrow-Tablet ".concat(currentDataIndex === filterData.length - 1
        ? 'pps-mobileRightArrowDisable pps-mobileRightArrowDisableTablet'
        : 'pps-mobileRightArrow pps-mobileRightArrowTablet');
    return (React.createElement("div", { className: "sui-relative" },
        React.createElement("button", { type: "button", disabled: currentDataIndex === filterData.length - 1, onClick: handleRightClick, className: mobileArrowRight },
            React.createElement(ArrowForward, { color: "current" }))));
};
var useRenderNavigation = function () {
    var _a = React.useContext(InfoPerksContext), perksInfo = _a.perksInfo, isLoading = _a.isLoading;
    var _b = React.useContext(PerkProgressContext), controlToggle = _b.controlToggle, filterData = _b.filterData, detailsPlcc = _b.detailsPlcc, plccSwitch = _b.plccSwitch, currentDataIndex = _b.currentDataIndex, prevDataIndex = _b.prevDataIndex, showUnlockAnimation = _b.showUnlockAnimation;
    var _c = useRenderIcons(), TrackerLeftIcon = _c.TrackerLeftIcon, TrackerRightIcon = _c.TrackerRightIcon, TrackerLeftMobileIcon = _c.TrackerLeftMobileIcon, TrackerRightMobileIcon = _c.TrackerRightMobileIcon;
    var RenderDeskTopNavigation = function () {
        var currentIndexBack = filterData[currentDataIndex - 1];
        var currentIndexNext = filterData[currentDataIndex + 1];
        var currentDataSelected = filterData[currentDataIndex];
        var prevIndexBack = currentDataIndex === prevDataIndex
            ? currentIndexBack
            : filterData[prevDataIndex - 1];
        var prevIndexNext = currentDataIndex === prevDataIndex
            ? currentIndexNext
            : filterData[prevDataIndex + 1];
        return (React.createElement(Grid, { item: true, md: 12 },
            React.createElement(Grid, { className: "process" },
                React.createElement(ShowSpendStatus, { data: { item: currentDataSelected }, showUnlockAnimation: showUnlockAnimation }),
                React.createElement(Grid, { item: true, className: "mobileProcessTimeline" },
                    React.createElement(Grid, { item: true, className: "stepSeperator" }),
                    React.createElement(LeftNavigationDesktop, { currentDataIndex: currentDataIndex }),
                    React.createElement(Grid, { container: true, className: "container_circleAndIcons" },
                        React.createElement(Grid, { item: true, md: 2, lg: 4, xs: 2 },
                            React.createElement(TrackerLeftIcon, { prevData: { item: prevIndexBack }, data: { item: currentIndexBack } })),
                        React.createElement(Grid, { item: true, md: 2, lg: 4, className: "container_progressCircle" },
                            React.createElement(RenderDesktopProgressCircle, { data: { item: currentDataSelected }, perksInfo: perksInfo, controlToggle: controlToggle, detailsPlcc: detailsPlcc, plccSwitch: plccSwitch, isLoading: isLoading, showUnlockAnimation: showUnlockAnimation, currentDataIndex: currentDataIndex })),
                        React.createElement(Grid, { item: true, md: 2, lg: 4 },
                            React.createElement(TrackerRightIcon, { nextData: { item: prevIndexNext }, data: { item: currentIndexNext } }))),
                    React.createElement(RightNavigationDesktop, { filterData: filterData, currentDataIndex: currentDataIndex })))));
    };
    var RenderTabletNavigation = function () {
        var currentIndexBack = filterData[currentDataIndex - 1];
        var currentIndexNext = filterData[currentDataIndex + 1];
        var currentDataSelected = filterData[currentDataIndex];
        var prevIndexBack = currentDataIndex === prevDataIndex
            ? currentIndexBack
            : filterData[prevDataIndex - 1];
        var prevIndexNext = currentDataIndex === prevDataIndex
            ? currentIndexNext
            : filterData[prevDataIndex + 1];
        return (React.createElement(Grid, { container: true },
            React.createElement(Grid, { className: "processMobile" },
                React.createElement(ShowSpendStatus, { data: { item: currentDataSelected }, showUnlockAnimation: showUnlockAnimation }),
                React.createElement(Grid, { className: "mobileProcessTimeline" },
                    React.createElement("div", { className: "stepSeporator-glow sS-g_left" }),
                    React.createElement(Grid, { className: "stepSeperator" }),
                    React.createElement("div", { className: "stepSeporator-glow sS-g_right" }),
                    React.createElement(Grid, { container: true },
                        React.createElement(Grid, { item: true, md: 3 },
                            React.createElement(TrackerLeftMobileIcon, { prevData: { item: prevIndexBack }, data: { item: currentIndexBack } }),
                            React.createElement(LeftNavigationTablet, { currentDataIndex: currentDataIndex })),
                        React.createElement(Grid, { item: true, md: 6 },
                            React.createElement(RenderDesktopProgressCircle, { data: { item: currentDataSelected }, perksInfo: perksInfo, controlToggle: controlToggle, detailsPlcc: detailsPlcc, plccSwitch: plccSwitch, isLoading: isLoading, showUnlockAnimation: showUnlockAnimation, currentDataIndex: currentDataIndex })),
                        React.createElement(Grid, { item: true, md: 3 },
                            React.createElement(TrackerRightMobileIcon, { nextData: { item: prevIndexNext }, data: { item: currentIndexNext } }),
                            React.createElement(RightNavigationTablet, { filterData: filterData, currentDataIndex: currentDataIndex })))))));
    };
    return { RenderDeskTopNavigation: RenderDeskTopNavigation, RenderTabletNavigation: RenderTabletNavigation };
};
var RenderPerkProgress = function () {
    var isLegacyDesktop = React.useContext(PerkProgressContext).isLegacyDesktop;
    var _a = useRenderNavigation(), RenderDeskTopNavigation = _a.RenderDeskTopNavigation, RenderTabletNavigation = _a.RenderTabletNavigation;
    return (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Grid, { container: true }, isLegacyDesktop ? (React.createElement(RenderDeskTopNavigation, null)) : (React.createElement(RenderTabletNavigation, null)))));
};
var RenderCardPayment = function () {
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var _a = React.useContext(PerkProgressContext), controlToggle = _a.controlToggle, setControlToggle = _a.setControlToggle;
    var _b = useState(false), hasToggleBeenUsed = _b[0], setHasToggleBeenUsed = _b[1];
    var pxccCounter = perksInfo.activePxccFactor;
    var toggle = function () {
        // Added if to only call analytics once per document
        if (!hasToggleBeenUsed) {
            setHasToggleBeenUsed(true);
            setEditEvent('perks: pxcc enrolled', !controlToggle ? '4x toggle on' : '4x toggle off');
        }
        setControlToggle(!controlToggle);
    };
    return (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement("div", { className: "perkProgressSpend__cardPaymentbox sui-pb-5" },
            React.createElement("div", { className: "cardPaymentbox-container" },
                React.createElement("span", { className: (controlToggle
                        ? 'perkProgressSpend__cardLabel sui-font-bold'
                        : '') + ' cardPaymentbox-leftText' },
                    "With",
                    ' ',
                    React.createElement("span", { className: "perkProgressSpend__modelCircle" },
                        pxccCounter,
                        "X"),
                    ' ',
                    "Card"),
                React.createElement("div", { className: "toggle-controlToggle" },
                    React.createElement(Toggle, { checked: controlToggle, onChange: toggle, inputAttributes: { 'aria-label': 'controlled' } })),
                controlToggle ? 'With Other Payments' : React.createElement("b", null, "With Other Payments")))));
};
var RenderDesktopToggle = function () {
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var _a = React.useContext(PerkProgressContext), filterData = _a.filterData, plccSwitch = _a.plccSwitch, currentDataIndex = _a.currentDataIndex;
    var currentDataSelected = filterData[currentDataIndex];
    var earnedTier = currentDataSelected.earned;
    var currentTier = !earnedTier && perksInfo.currentTierId === currentDataSelected.tierId;
    var futureTier = !earnedTier && perksInfo.nextTierId === currentDataSelected.tierId;
    return (React.createElement(Grid, { container: true },
        ' ',
        plccSwitch && (currentTier || futureTier) && React.createElement(RenderCardPayment, null),
        ' '));
};
// Main
export var PerkProgressSpend = React.memo(function (props) {
    var showUnlockAnimation = React.useContext(PerkProgressContext).showUnlockAnimation;
    useEffect(function () {
        sessionStorage.setItem('showUnlockAnimation', JSON.stringify(showUnlockAnimation));
    }, [showUnlockAnimation]);
    return (React.createElement(Grid, { container: true },
        React.createElement(Grid, { item: true, xs: 12 }),
        React.createElement(Hidden, { mdDown: true },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(RenderPerkProgress, null),
                React.createElement(RenderDesktopToggle, null)))));
});
